'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Guard core modules from being re-imported.
 *
 * @export
 * @param {*} parentModule
 * @param {string} moduleName
 */
function throwIfAlreadyLoaded(parentModule, moduleName) {
  if (parentModule) {
    throw new Error("".concat(moduleName, " has already been loaded. Import Core modules in the AppModule only."));
  }
}

exports.throwIfAlreadyLoaded = throwIfAlreadyLoaded;
